/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomizationProductIngredientFragment = {
  readonly __typename: 'Ingredient';
  readonly id: string;
  readonly name: string;
  readonly isMixable: boolean | null;
  readonly isGrain: boolean | null;
  readonly totalCarbsG: number | null;
  readonly proteinG: number | null;
  readonly totalFatG: number | null;
  readonly calories: number | null;
  readonly kind: Types.IngredientKind | null;
  readonly asset: { readonly __typename: 'Asset'; readonly url: string };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename: 'DietaryProperty';
    readonly id: string;
    readonly name: Types.DietaryPropertyKind;
  }>;
};

export type CustomizationProductFragment = {
  readonly __typename: 'Product';
  readonly id: string;
  readonly slug: string;
  readonly restaurantId: string;
  readonly name: string;
  readonly description: string;
  readonly calories: number;
  readonly outOfStock: boolean;
  readonly maxModifications: number;
  readonly isModifiable: boolean;
  readonly isCustom: boolean;
  readonly enableDressingDetails: boolean;
  readonly cost: number;
  readonly asset: { readonly __typename: 'Asset'; readonly url: string };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename: 'DietaryProperty';
    readonly id: string;
    readonly name: Types.DietaryPropertyKind;
  }>;
  readonly ingredients: ReadonlyArray<{
    readonly __typename: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly isMixable: boolean | null;
    readonly isGrain: boolean | null;
    readonly totalCarbsG: number | null;
    readonly proteinG: number | null;
    readonly totalFatG: number | null;
    readonly calories: number | null;
    readonly kind: Types.IngredientKind | null;
    readonly asset: { readonly __typename: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename: 'DietaryProperty';
      readonly id: string;
      readonly name: Types.DietaryPropertyKind;
    }>;
  }>;
  readonly modifierGroups: ReadonlyArray<{
    readonly __typename: 'ModifierGroup';
    readonly id: string;
    readonly name: string;
    readonly displayName: string;
    readonly maxAggregateQuantity: number;
    readonly minAggregateQuantity: number;
    readonly freeAggregateQuantity: number;
    readonly allowMultipleQuantity: boolean;
    readonly encourageAboveMinSelection: boolean;
    readonly encourageMaxSelection: boolean;
    readonly restaurantId: string;
    readonly helperText: string | null;
    readonly variation: Types.ModifierGroupVariation;
    readonly groupRole: string | null;
    readonly pairedGroupId: string | null;
    readonly hasDynamicMax: boolean | null;
    readonly modifications: ReadonlyArray<{
      readonly __typename: 'IngredientModifier';
      readonly id: string;
      readonly ingredientId: string | null;
      readonly additionCost: number;
      readonly removalCost: number;
      readonly substitutionCost: number;
      readonly subKind: string | null;
      readonly outOfStock: boolean | null;
      readonly ingredient: {
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly isMixable: boolean | null;
        readonly isGrain: boolean | null;
        readonly totalCarbsG: number | null;
        readonly proteinG: number | null;
        readonly totalFatG: number | null;
        readonly calories: number | null;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly __typename: 'Asset'; readonly url: string };
        readonly dietaryProperties: ReadonlyArray<{
          readonly __typename: 'DietaryProperty';
          readonly id: string;
          readonly name: Types.DietaryPropertyKind;
        }>;
      } | null;
    }>;
  }>;
};

export type CustomizationRestaurantFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly isOutpost: boolean;
};

export type CustomizationDataQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
  restaurantId: Types.Scalars['ID']['input'];
  costChannel?: Types.InputMaybe<Types.CostChannel>;
  caloriesVersion?: Types.InputMaybe<Types.CaloriesVersion>;
  ingredientAssetVersion?: Types.InputMaybe<Types.IngredientAssetVersion>;
  modifierGroupVersion?: Types.InputMaybe<Types.ModifierGroupVersion>;
}>;

export type CustomizationDataQuery = {
  readonly __typename?: 'Query';
  readonly product: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly restaurantId: string;
    readonly name: string;
    readonly description: string;
    readonly calories: number;
    readonly outOfStock: boolean;
    readonly maxModifications: number;
    readonly isModifiable: boolean;
    readonly isCustom: boolean;
    readonly enableDressingDetails: boolean;
    readonly cost: number;
    readonly asset: { readonly __typename: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename: 'DietaryProperty';
      readonly id: string;
      readonly name: Types.DietaryPropertyKind;
    }>;
    readonly ingredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly isMixable: boolean | null;
      readonly isGrain: boolean | null;
      readonly totalCarbsG: number | null;
      readonly proteinG: number | null;
      readonly totalFatG: number | null;
      readonly calories: number | null;
      readonly kind: Types.IngredientKind | null;
      readonly asset: { readonly __typename: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename: 'DietaryProperty';
        readonly id: string;
        readonly name: Types.DietaryPropertyKind;
      }>;
    }>;
    readonly modifierGroups: ReadonlyArray<{
      readonly __typename: 'ModifierGroup';
      readonly id: string;
      readonly name: string;
      readonly displayName: string;
      readonly maxAggregateQuantity: number;
      readonly minAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly encourageAboveMinSelection: boolean;
      readonly encourageMaxSelection: boolean;
      readonly restaurantId: string;
      readonly helperText: string | null;
      readonly variation: Types.ModifierGroupVariation;
      readonly groupRole: string | null;
      readonly pairedGroupId: string | null;
      readonly hasDynamicMax: boolean | null;
      readonly modifications: ReadonlyArray<{
        readonly __typename: 'IngredientModifier';
        readonly id: string;
        readonly ingredientId: string | null;
        readonly additionCost: number;
        readonly removalCost: number;
        readonly substitutionCost: number;
        readonly subKind: string | null;
        readonly outOfStock: boolean | null;
        readonly ingredient: {
          readonly __typename: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly isMixable: boolean | null;
          readonly isGrain: boolean | null;
          readonly totalCarbsG: number | null;
          readonly proteinG: number | null;
          readonly totalFatG: number | null;
          readonly calories: number | null;
          readonly kind: Types.IngredientKind | null;
          readonly asset: { readonly __typename: 'Asset'; readonly url: string };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        } | null;
      }>;
    }>;
  };
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly isOutpost: boolean;
  } | null;
};

export type CustomizationEditDataQueryVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
  restaurantId: Types.Scalars['ID']['input'];
  lineItemInput: Types.LineItemInput;
  costChannel?: Types.InputMaybe<Types.CostChannel>;
  caloriesVersion?: Types.InputMaybe<Types.CaloriesVersion>;
  ingredientAssetVersion?: Types.InputMaybe<Types.IngredientAssetVersion>;
  modifierGroupVersion?: Types.InputMaybe<Types.ModifierGroupVersion>;
}>;

export type CustomizationEditDataQuery = {
  readonly __typename?: 'Query';
  readonly product: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly slug: string;
    readonly restaurantId: string;
    readonly name: string;
    readonly description: string;
    readonly calories: number;
    readonly outOfStock: boolean;
    readonly maxModifications: number;
    readonly isModifiable: boolean;
    readonly isCustom: boolean;
    readonly enableDressingDetails: boolean;
    readonly cost: number;
    readonly asset: { readonly __typename: 'Asset'; readonly url: string };
    readonly dietaryProperties: ReadonlyArray<{
      readonly __typename: 'DietaryProperty';
      readonly id: string;
      readonly name: Types.DietaryPropertyKind;
    }>;
    readonly ingredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly isMixable: boolean | null;
      readonly isGrain: boolean | null;
      readonly totalCarbsG: number | null;
      readonly proteinG: number | null;
      readonly totalFatG: number | null;
      readonly calories: number | null;
      readonly kind: Types.IngredientKind | null;
      readonly asset: { readonly __typename: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename: 'DietaryProperty';
        readonly id: string;
        readonly name: Types.DietaryPropertyKind;
      }>;
    }>;
    readonly modifierGroups: ReadonlyArray<{
      readonly __typename: 'ModifierGroup';
      readonly id: string;
      readonly name: string;
      readonly displayName: string;
      readonly maxAggregateQuantity: number;
      readonly minAggregateQuantity: number;
      readonly freeAggregateQuantity: number;
      readonly allowMultipleQuantity: boolean;
      readonly encourageAboveMinSelection: boolean;
      readonly encourageMaxSelection: boolean;
      readonly restaurantId: string;
      readonly helperText: string | null;
      readonly variation: Types.ModifierGroupVariation;
      readonly groupRole: string | null;
      readonly pairedGroupId: string | null;
      readonly hasDynamicMax: boolean | null;
      readonly modifications: ReadonlyArray<{
        readonly __typename: 'IngredientModifier';
        readonly id: string;
        readonly ingredientId: string | null;
        readonly additionCost: number;
        readonly removalCost: number;
        readonly substitutionCost: number;
        readonly subKind: string | null;
        readonly outOfStock: boolean | null;
        readonly ingredient: {
          readonly __typename: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly isMixable: boolean | null;
          readonly isGrain: boolean | null;
          readonly totalCarbsG: number | null;
          readonly proteinG: number | null;
          readonly totalFatG: number | null;
          readonly calories: number | null;
          readonly kind: Types.IngredientKind | null;
          readonly asset: { readonly __typename: 'Asset'; readonly url: string };
          readonly dietaryProperties: ReadonlyArray<{
            readonly __typename: 'DietaryProperty';
            readonly id: string;
            readonly name: Types.DietaryPropertyKind;
          }>;
        } | null;
      }>;
    }>;
  };
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly isOutpost: boolean;
  } | null;
  readonly lineItem:
    | { readonly __typename: 'LineItemNotFound' }
    | {
        readonly __typename: 'LineItemSuccess';
        readonly lineItem: {
          readonly __typename: 'LineItem';
          readonly id: string;
          readonly quantity: number;
          readonly isCustom: boolean;
          readonly customName: string | null;
          readonly ingredients: ReadonlyArray<{
            readonly __typename: 'Ingredient';
            readonly id: string;
            readonly name: string;
            readonly isMixable: boolean | null;
            readonly isGrain: boolean | null;
            readonly totalCarbsG: number | null;
            readonly proteinG: number | null;
            readonly totalFatG: number | null;
            readonly calories: number | null;
            readonly kind: Types.IngredientKind | null;
            readonly asset: { readonly __typename: 'Asset'; readonly url: string };
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename: 'DietaryProperty';
              readonly id: string;
              readonly name: Types.DietaryPropertyKind;
            }>;
          }>;
          readonly mixedDressingDetails: ReadonlyArray<{
            readonly __typename: 'MixedDressingDetails';
            readonly ingredientId: string;
            readonly weight: Types.DressingWeight;
          }>;
        };
      }
    | { readonly __typename: 'ValidationError' }
    | null;
};

export const CustomizationProductIngredientFragmentDoc = gql`
  fragment CustomizationProductIngredient on Ingredient {
    __typename
    id
    name
    isMixable
    isGrain
    totalCarbsG
    proteinG
    totalFatG
    calories(version: $caloriesVersion)
    asset(version: $ingredientAssetVersion) {
      __typename
      url
    }
    kind
    dietaryProperties {
      __typename
      id
      name
    }
  }
`;
export const CustomizationProductFragmentDoc = gql`
  fragment CustomizationProduct on Product {
    __typename
    id
    slug
    restaurantId
    name
    description
    cost: channelCost(costChannel: $costChannel)
    calories
    outOfStock
    maxModifications
    isModifiable
    isCustom
    enableDressingDetails
    asset {
      __typename
      url
    }
    dietaryProperties {
      __typename
      id
      name
    }
    ingredients(version: $modifierGroupVersion) {
      ...CustomizationProductIngredient
    }
    modifierGroups(version: $modifierGroupVersion) {
      __typename
      id
      name
      displayName
      maxAggregateQuantity
      minAggregateQuantity
      freeAggregateQuantity
      allowMultipleQuantity
      encourageAboveMinSelection
      encourageMaxSelection
      restaurantId
      helperText
      variation
      groupRole
      pairedGroupId
      hasDynamicMax
      modifications {
        __typename
        id
        ingredientId
        additionCost
        removalCost
        substitutionCost
        subKind
        outOfStock
        ingredient {
          ...CustomizationProductIngredient
        }
      }
    }
  }
  ${CustomizationProductIngredientFragmentDoc}
`;
export const CustomizationRestaurantFragmentDoc = gql`
  fragment CustomizationRestaurant on Restaurant {
    __typename
    id
    slug
    name
    isOutpost
  }
`;
export const CustomizationDataDocument = gql`
  query CustomizationData(
    $productId: ID!
    $restaurantId: ID!
    $costChannel: CostChannel
    $caloriesVersion: CaloriesVersion
    $ingredientAssetVersion: IngredientAssetVersion
    $modifierGroupVersion: ModifierGroupVersion
  ) {
    product(id: $productId) {
      ...CustomizationProduct
    }
    restaurant(id: $restaurantId) {
      ...CustomizationRestaurant
    }
  }
  ${CustomizationProductFragmentDoc}
  ${CustomizationRestaurantFragmentDoc}
`;

export function useCustomizationDataQuery(
  options: Omit<Urql.UseQueryArgs<CustomizationDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomizationDataQuery, CustomizationDataQueryVariables>({
    query: CustomizationDataDocument,
    ...options,
  });
}
export const CustomizationEditDataDocument = gql`
  query CustomizationEditData(
    $productId: ID!
    $restaurantId: ID!
    $lineItemInput: LineItemInput!
    $costChannel: CostChannel
    $caloriesVersion: CaloriesVersion
    $ingredientAssetVersion: IngredientAssetVersion
    $modifierGroupVersion: ModifierGroupVersion
  ) {
    product(id: $productId) {
      ...CustomizationProduct
    }
    restaurant(id: $restaurantId) {
      ...CustomizationRestaurant
    }
    lineItem(input: $lineItemInput) {
      __typename
      ... on LineItemSuccess {
        lineItem {
          ... on LineItem {
            __typename
            id
            quantity
            isCustom
            customName
            ingredients {
              ...CustomizationProductIngredient
            }
            mixedDressingDetails {
              __typename
              ingredientId
              weight
            }
          }
        }
      }
    }
  }
  ${CustomizationProductFragmentDoc}
  ${CustomizationRestaurantFragmentDoc}
  ${CustomizationProductIngredientFragmentDoc}
`;

export function useCustomizationEditDataQuery(
  options: Omit<Urql.UseQueryArgs<CustomizationEditDataQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomizationEditDataQuery, CustomizationEditDataQueryVariables>({
    query: CustomizationEditDataDocument,
    ...options,
  });
}
